<app-page-heading [title]="formTitle" [subheadingIcon]="'fa fa-user'"></app-page-heading>

<section class="container">
    <div class="btn-group chep-tabs">
        <button class="btn" [ngClass]="{'active' : activeTab === 'profile'}"
                (click)="activeTab = 'profile'">
            Profile
        </button>
        <button class="btn" [ngClass]="{'active' : activeTab === 'roles'}"
                (click)="activeTab = 'roles'">
            Roles
        </button>
    </div>

    <div class="row" [hidden]="activeTab !== 'profile'">
        <app-user-form #userForm [user]="user" [mode]="mode" [userTypeLabelKey]="'user'"
                       [create]="onCreate" [update]="onUpdate"
                       [remove]="onDelete" [block]="onToggleBlocking"
                       (changePassword)="changePassword($event)"
                       (afterCreate)="goToUserList()"
                       (afterDelete)="goToUserList()"
        ></app-user-form>
    </div>

    <div [hidden]="activeTab !== 'roles'">
        <div class="ibox float-e-margins">
            <div class="ibox-title border-primary">
                <div class="row">
                    <h5 class="col-xs-12 col-md-8">
                        User <strong>{{user.email}}</strong> is currently member of the following roles
                    </h5>

                    <div class="col-xs-12 col-md-4">
                        <button class="btn btn-primary btn-lg pull-right"
                                (click)="openAddRoleModal(addToRolesModal)">
                            <span class="fa fa-plus"></span> Add user to roles
                        </button>
                    </div>

                </div>
            </div>
            <div class="ibox-content summary-panel">
                <table class="table table-striped text-left">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let r of roles">
                        <td><a [routerLink]="['', 'userdashboard', 'roles', 'edit', r.id]">{{r.name}}</a></td>
                        <td>{{r.description}}</td>
                        <td class="text-center">
                            <button role="button" class="btn btn-outline-secondary btn-sm" [title]="'Remove from role'"
                                    (click)="openRemoveFromRoleConfirm(removeModal, r.id)">
                                <span class="fa fa-remove"></span>
                            </button>
                        </td>
                    </tr>
                    <tr *ngIf="roles?.length === 0">
                        <td colspan="3"><em>User is member of no role.</em></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>


<ng-template #removeModal>
    Are you sure you want to remove this user from the role ?
</ng-template>


<ng-template #addToRolesModal>
    <app-table-selection-modal [selectables]="selectableRoles"
                               [fieldsNames]="['', 'Role', 'Description']"
                               [fieldsEntries]="['id', 'name', 'description']"
                               (selectedChange)="selectedRoles = $event">
    </app-table-selection-modal>
</ng-template>
